import { Box, Button, Container, Grid2 as Grid, Icon, Paper, Skeleton, Typography } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import Icons from "../../../assets/js/Icons"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { retrieveDashboardStats } from "../../../redux/admin-slices/dashboard.slice"

const tileData = [
  { name: "Total Specialists", key: "totalSpecialists", icon: <Icons.UserMultipleSolid />, path: "/specialists/all" },
  { name: "Total Members", key: "totalMembers", icon: <Icons.UserMultipleSolid />, path: "/members/all" },
  { name: "Total Forums", key: "totalForums", icon: <Icons.LicenseSolid />, path: "/forum/all" },
  { name: "Total Blogs", key: "totalBlogs", icon: <Icons.LicenseSolid />, path: "/blogs/all" },
]

function Summary() {
  const dispatch = useDispatch()
  const { stats, loading } = useSelector((state) => state.dashboardSlice)

  useEffect(() => {
    dispatch(retrieveDashboardStats())
  }, [dispatch])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box sx={{ mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: "32px",
              lineHeight: "1.2",
              fontWeight: "500"
            }}
            variant="pageTitle"
          >Overview
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {tileData?.map((item, i) => (
          <Grid key={i} size={{ xs: 12, md: 6, xl: 4, xxl: 3 }}>
            <Paper variant="summaryTile">
              <Typography
                mb={2}
                fontSize={18}
                fontWeight="500"
                color="other.dark1"
              >{item?.name}
              </Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid size="grow">
                  {loading ? (
                    <Skeleton width={60} height={40} />
                  ) : (
                    <Typography
                      mb={2}
                      fontSize={28}
                      fontWeight="700"
                      color="other.dark1"
                    >{stats?.[item.key] || 0}
                    </Typography>
                  )}
                  <Button
                    sx={{
                      lineHeight: "1.2"
                    }}
                    to={item?.path}
                    size="small"
                    variant="outlined"
                    LinkComponent={NavLink}
                  >View All
                  </Button>
                </Grid>
                <Grid size="auto">
                  <Icon sx={{ fontSize: 60, color: "primary.main", overflow: "visible" }}>
                    {item?.icon}
                  </Icon>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ))
        }
      </Grid>
    </Container>
  )
}

export default Summary